import { memo } from "react";
import ReactMarkdown, { type Components } from "react-markdown";
import remarkGfm from "remark-gfm";

const components: Components = {
  a: ({ href, children, node: _node, ...rest }) => {
    const external = !!href && /^https?:\/\//.test(href) && !href.startsWith(window.location.origin);
    return (
      <a
        href={href}
        {...rest}
        {...(external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        {children}
      </a>
    );
  },
  img: ({ src, alt, node: _node, ...rest }) => (
    <a href={typeof src === "string" ? src : undefined} target="_blank" rel="noopener noreferrer">
      <img src={src} alt={alt ?? ""} loading="lazy" {...rest} />
    </a>
  ),
};

export const Markdown = memo(function Markdown({
  children,
  className,
}: {
  children: string | null | undefined;
  className?: string;
}) {
  return (
    <div className={`markdown ${className ?? ""}`}>
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={components}>
        {children ?? ""}
      </ReactMarkdown>
    </div>
  );
});
